import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { ApiService } from 'src/app/_shared/services/api.service';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EMPTY, of, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AemService } from '../../../_shared/services/aem-content.service';
import { AdobeDtmService } from '../../../_shared/services/adobe-dtm.service';

@Component({
  selector: 'app-gmvehicles',
  templateUrl: './gmvehicles.component.html',
  styleUrl: './gmvehicles.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GmvehiclesComponent implements OnInit, OnDestroy {
  componentDestroyed = new Subject<void>();
  modelSelection = {
    All: 'All',
    Car: 'Car',
    'SUV/Crossover': 'SUV',
    Truck: 'Truck'
  };
  listOfBrands = [
    { name: 'Chevrolet', value: 0 },
    { name: 'Buick', value: 1 },
    { name: 'GMC', value: 2 },
    { name: 'Cadillac', value: 4 }
  ];

  chevyLogo;
  buickLogo;
  cadillacLogo;
  gmcLogo;

  viewAllChevy = { value: false };
  viewAllBuick = { value: false };
  viewAllCadillac = { value: false };
  viewAllGmc = { value: false };

  chevyBtn1Link;
  buickBtn1Link;
  gmcBtn1Link;
  cadillacBtn1Link;

  buickList;
  chevyList;
  gmcList;
  cadillacList;
  pageInformation;

  buickListFilter;
  chevyListFilter;
  gmcListFilter;
  cadillacListFilter;
  selectedType = '';
  digitalData;

  constructor(
    private readonly apiService: ApiService,
    private aem: AemService,
    private adobeDTMService: AdobeDtmService
  ) {}
  ngOnInit(): void {
    this.getAemContent();
    this.setAnalytics();
  }
  setAnalytics() {
    // Set up digital data object
    this.digitalData = {
      pageInfo: {
        cardType: '',
        cardTypeOwned: '',
        loginType: '',
        offerID: '',
        pageName: 'vehicles | logged | gmb',
        pageSubType: '',
        pageType: 'vehicles'
      }
    };

    this.digitalData = this.adobeDTMService.setupWindowPageInfoData(
      this.digitalData,
      'vehicles',
      'vehicles'
    );

    this.adobeDTMService.setWindowObjectData(this.digitalData);
    this.adobeDTMService.sendAdobeLaunchData();
  }
  getAemContent() {
    this.apiService.getAemPage('vehicle-information').subscribe(resp => {
      this.chevyList = JSON.parse(resp.chevrolet);
      this.buickList = JSON.parse(resp.buick);
      this.gmcList = JSON.parse(resp.gmc);
      this.cadillacList = JSON.parse(resp.cadillac);
      this.chevyListFilter = this.chevyList;
      this.cadillacListFilter = this.cadillacList;
      this.buickListFilter = this.buickList;
      this.gmcListFilter = this.gmcList;
      this.pageInformation = JSON.parse(resp.pageInformation);
      this.chevyLogo = `${environment.API_URL}/getAemImage?image=${this.pageInformation.chevyImage}`;
      this.buickLogo = `${environment.API_URL}/getAemImage?image=${this.pageInformation.buickImage}`;
      this.cadillacLogo = `${environment.API_URL}/getAemImage?image=${this.pageInformation.cadillacImage}`;
      this.gmcLogo = `${environment.API_URL}/getAemImage?image=${this.pageInformation.gmcImage}`;
      this.chevyBtn1Link = this.pageInformation.chevyButton1Link;
      this.buickBtn1Link = this.pageInformation.buickButton1Link;
      this.gmcBtn1Link = this.pageInformation.gmcButton1Link;
      this.cadillacBtn1Link = this.pageInformation.cadillacButton1Link;
    });
  }
  filterVehicleList(newVal: string) {
    if (newVal != 'All') {
      this.chevyListFilter = this.chevyList.filter(
        item => item.style == newVal
      );
      this.cadillacListFilter = this.cadillacList.filter(
        item => item.style == newVal
      );
      this.buickListFilter = this.buickList.filter(
        item => item.style == newVal
      );
      this.gmcListFilter = this.gmcList.filter(item => item.style == newVal);
    } else {
      this.chevyListFilter = this.chevyList;
      this.cadillacListFilter = this.cadillacList;
      this.buickListFilter = this.buickList;
      this.gmcListFilter = this.gmcList;
    }
    this.viewAllChevy.value = false;
    this.viewAllBuick.value = false;
    this.viewAllCadillac.value = false;
    this.viewAllGmc.value = false;
  }
  ngOnDestroy(): void {
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }
}
